import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
import { homeFaqs, type FaqItem } from '../../config/faq';
import { SectionHeading } from '../ui/SectionHeading';

interface FAQSectionProps {
  items?: readonly FaqItem[];
  eyebrow?: string;
  title?: string;
  text?: string;
  id?: string;
}

export function FAQSection({
  items = homeFaqs,
  eyebrow = 'Frequently asked',
  title = 'Clear answers before you start.',
  text = 'Scope, collaboration, ownership, multilingual work and optional previews are agreed clearly before the build moves forward.',
  id = 'faq',
}: FAQSectionProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="section faq" id={id}>
      <div className="shell faq__grid">
        <SectionHeading
          eyebrow={eyebrow}
          title={title}
          text={text}
        />
        <div className="faq-list">
          {items.map((item, index) => {
            const active = open === index;
            return (
              <div className={`faq-item ${active ? 'faq-item--open' : ''}`} key={item.question}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={active}
                    aria-controls={`faq-panel-${index}`}
                    onClick={() => setOpen(active ? null : index)}
                  >
                    <span>{item.question}</span>
                    {active ? <Minus aria-hidden="true" /> : <Plus aria-hidden="true" />}
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} className="faq-item__panel" hidden={!active}>
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
